<template>
    <div>
        <div class="row wizard">
            <div class="col-md-12 link" :class="{'current':pageNumber==widgetLink.Id, 'done':pageNumber>widgetLink.Id,
                'notdone':pageNumber<widgetLink.Id}" v-for="(widgetLink, index) in navigationLinks" v-bind:key="index">
                {{widgetLink.Id}}. {{widgetLink.Name}}
                <span v-show="pageNumber>widgetLink.Id" > <i class="padding-bottom-3 material-icons">&#xE876;</i></span>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: "NavigationLink",
    computed: {
        ...mapGetters({
            navigationLinks: 'navigationLinks',
            pageNumber: 'pageNumber'
        })
    }
}
</script>




// WEBPACK FOOTER //
// src/components/NavigationLink.vue